import firebaseService from "../firebase/FirebaseService";
import { addStudentToGroup, getGroupsOfStudent, getSubscribedActivitiesByUserId, removeActivityFromUser, removeStudentFromGroup } from "./NewGroupService";

export const createUsersProcess = async (payload, userGroup) => {
  return new Promise(async (resolve, reject) => {
    if (!userGroup)
      return resolve({ type: "error", message: "No se encontro el grupo del tipo especificado!" });

    const group = await firebaseService.getGroupById(userGroup);

    if (!group)
      return resolve({ type: "error", message: "No se encontro el grupo del tipo especificado!" });

    await Promise.all(payload.map((usr) => firebaseService.setUser(usr)));
    await Promise.all(payload.map((usr) => addStudentToGroup(usr.email, group.id)));

    return resolve({ type: "success", message: "Se guardaron los usuarios exitosamente!" });
  });
};

export const createUser = async (payload) => {
  return firebaseService
    .createUser(payload)
    .then((response) => {
      // const userId = response.id;
      return response;
    })
    .catch((e) => {
      return "error";
    });
};

export const updateUser = async (userId, payload) => {
  return firebaseService
    .updateUser(userId, payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      return "error";
    });
};

export const deleteUser = async (userId) => {
  return firebaseService
    .updateUser(userId, { deleted: true })
    .then(async (response) => {
      const activities = await getSubscribedActivitiesByUserId(userId);
      const groups = await getGroupsOfStudent(userId);

      await Promise.all(activities.map((act) => removeActivityFromUser(userId, act.id)));
      await Promise.all(groups.map((grp) => removeStudentFromGroup(userId, grp.id)));

      return response;
    })
    .catch((e) => {
      return "error";
    });
};

export const disableMultiUsers = async (usersId) => {
  return firebaseService
    .disableMultiUsers(usersId)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      return "error";
    });
};

export const getLoggedUser = async () => {
  return firebaseService
    .getLoggedUser()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return [];
    });
};

export const getUsers = async () => {
  return firebaseService
    .getUsers()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return [];
    });
};

export const getTeachers = async () => {
  return firebaseService
    .getTeachers()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return [];
    });
};

export const getUsersTeacher = async () => {
  return firebaseService
    .getUsersTeacher()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return [];
    });
};

export const getUserById = async (userId) => {
  return firebaseService
    .getUserById(userId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return null;
    });
};

export const getUsersWithoutGroup = async () => {
  return firebaseService.getUsersWithoutGroup()
    .then((response) => {
      return response;
    })
    .catch(error => {
      return [];
    });
};
